export type BaseRoute = '/' | '/about' | '/projects' | '/coding' | '/publishing' | '/creators' | '/portal' | '/support';
export type ProjectRoute = `/projects/${string}`;
export type Route = BaseRoute | ProjectRoute;

export const routes: BaseRoute[] = ['/', '/about', '/projects', '/coding', '/publishing', '/creators', '/portal', '/support'];
